const URLS = {
  LOGIN: '/api/auth/login',
  RECONNECT: '/api/auth/reconnect',

  BLOCK: '/api/customer/block/soft',
  UNBLOCK: '/api/customer/unblock',
  
  CUSTOMER: '/api/customer',
  CURRENT_CUSTOMER: '/api/customer/current',
  POST_CUSTOMER: '/api/customer/register',
  CUSTOMER_SEARCH: {
    EMAIL: '/api/customer/email',
    CNPJ: '/api/customer/cnpj'
  },

  FINANCIAL: {
    PAYMENT: '/api/financial/payment',
    SUBSCRIPTION: '/api/financial/subscription',
    CONFIG: {
      ISS_TAX: '/api/financial/issTax'
    }
  },

  PLAN: {
    CURRENT_PLAN_TABLE: '/api/plan/table/current',
    ADD_PLAN: '/api/plan/table/addPlan',
    TABLE: '/api/plan/table',
    ROOT: '/api/plan'
  },

  PRODUCT: {
    CURRENT_PRODUCT_TABLE: '/api/product/table/current',
    ADD_PRODUCT: '/api/plan/table/addProduct',
    TABLE: '/api/product/table',
    ROOT: '/api/product'
  },

  MARKETPLACE: '/api/marketplace',

  FILTER: {
    ROOT: '/api/filters',
    USERS: '/users'
  },

  NOTIFICATION: {
    ROOT: '/api/notifications'
  },

  MANAGER_LOG: {
    MANAGER_EMAIL: '/api/managerLog/manager',
    ACTION_CLASS: '/api/managerLog/actionClass',
    ACTION: '/api/managerLog/action',
    MONTH: '/api/managerLog/month'
  }
}

export default URLS